import script from "./asidebarMenuDesktopApp.vue?vue&type=script&setup=true&lang=js"
export * from "./asidebarMenuDesktopApp.vue?vue&type=script&setup=true&lang=js"

import "./asidebarMenuDesktopApp.vue?vue&type=style&index=0&id=a70cebf2&scoped=true&lang=css"

import exportComponent from "/builds/portal-da-transparencia/cge-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a70cebf2"]])

export default __exports__